'use strict';

(function () {
	'use strict';

	trafficService.$inject = ['$http', '$q', 'appConfig', 'baseService'];
	angular.module('app.services').factory('trafficService', trafficService);

	function trafficService($http, $q, appConfig, baseService) {
		'ngInject';

		var service = {
			getGroupedData: getGroupedData,
			getScanners: getScanners
		};

		return service;

		////////////////


		function decode(str) {
			return str.replace(/&#(\d+);/g, function (match, dec) {
				return String.fromCharCode(dec);
			});
		}

		function getRawData() {
			var params = {};
			return $http.get(appConfig.trafficUrl + '/data', {
				params: params,
				transformResponse: $http.defaults.transformResponse.concat(baseService.createDateAttrTransformer('created'))
			}).then(function (result) {
				var data = [];

				result.data.forEach(function (entry) {
					data.push({
						at: entry.created,
						count: parseInt(entry.object_counter),
						scanner_id: entry.scanner_id,
						direction: entry.direction,
						object_type: entry.object_type
					});
				});

				data.sort(function (a, b) {
					// Turn your strings into dates, and then subtract them
					// to get a value that is either negative, positive, or zero.
					return new Date(a.at) - new Date(b.at);
				});

				return data;
			});
		}

		/**
   * 
   */
		function getGroupedData() {

			return $q.all({
				rawData: getRawData()
			}).then(function (result) {
				var values = [];
				var filteredArray = _.groupBy(result.rawData, 'scanner_id');
				var tmp = Object.values(filteredArray);
				tmp.forEach(function (station, index) {

					var filterDirection = _.groupBy(station, 'direction');
					Object.values(filterDirection).forEach(function (direction) {

						var filterType = _.groupBy(direction, 'object_type');

						var sample = Object.values(filterType)[0];

						if (!values[sample[0].scanner_id]) {
							values[sample[0].scanner_id] = [];
						}
						if (!values[sample[0].scanner_id][sample[0].direction]) {
							values[sample[0].scanner_id][sample[0].direction] = [];
						}

						Object.entries(filterType).forEach(function (type) {
							var objectType = {
								key: [type[0]], //sample[0].scanner_id, sample[0].direction,
								color: getLineColor(type[0]),
								values: type[1] || [],
								min: _.minBy(type[1], 'count'),
								max: _.maxBy(type[1], 'count')
							};

							values[sample[0].scanner_id][sample[0].direction].push(objectType);
						});
					});
				});

				return values;
			});
		}

		function getLineColor(type) {
			var colorMap = {
				'car': '#F8A500',
				'bus': '#9B5196',
				'truck': '#F67B3B',
				'person': '#344B7E',
				'bicycle': '#fff',
				'motorbike': '#F05B68'
			};
			var color = '#fff';

			return colorMap[type] ? colorMap[type] : color;
		}

		/**
   * 
   */
		function getScanners() {
			var params = {};

			return $http.get(appConfig.trafficUrl + '/scanners', {
				params: params
			}).then(function (r) {
				var result = r.data;

				var newArray = [];
				Object.keys(result).forEach(function (item) {
					result[item].name = decode(result[item].name);
					result[item].name_el = decode(result[item].name_el);
					newArray.push(result[item]);
				});

				return newArray;
			});
		}
	}
})();